import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

import {
  LD_TOGGLE_FEATURES,
  LD_TOGGLE_FEATURES_TYPES,
} from 'config/launchDarkly'
import { GET_VARIATION } from 'hooks/useVariation/GET_VARIATION'
import { useWorkspace } from 'hooks/useWorkspace'

export const useVariation = <K extends LD_TOGGLE_FEATURES>(name?: K) => {
  const { workspace, workspaceId } = useWorkspace()

  const result = useQuery<{ me: { variation: LD_TOGGLE_FEATURES_TYPES[K] } }>(
    GET_VARIATION,
    {
      variables: { name, workspace, workspaceId },
      skip: !name || !workspace || !workspaceId,
      fetchPolicy: 'no-cache',
    }
  )

  return useMemo(
    () => ({
      ...result,
      variation: result?.data?.me?.variation,
    }),
    [result]
  )
}
